/* eslint-disable ember/classic-decorator-hooks, ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';

import * as CommonUtils from '../../../utils/common';

export default class CircuitDetailResults extends EmberObject {
  circuit;
  componentInput;
  stage;
  whoAmI = 'app/models/results/sub-results/circuit-details.js';
  stageLetter; // string (e.g: "A", "B")
  order; // int
  filter; // string
  implementation; // string
  vsPlus; // "5V"
  vsMinus; // "-5V"
  bypassCapacitors; // array of { name: "c1", value: "1nF", tolerance: "5%" },
  spares; // array of { name: "LT2078", url: "" }

  init() {
    super.init();
    if (!CommonUtils.isNullOrUndefined(this.stage)) {
      this.stageLetter = this.stage.stageLetter;
      this.order = this.stage.order;
      this.filter = this.stage.filter;
      this.implementation = this.stage.implementation.name;
    }

    if (!CommonUtils.isNullOrUndefined(this.componentInput)) {
      this.vsPlus = this.componentInput.vsPlus;
      this.vsMinus = this.componentInput.vsMinus;
    }
  }

  @computed('circuit') get c1() {
    var c1 = this.circuit.c1;
    var result = { name: '', value: null, tolerance: null, minimum: null, maximum: null };
    if (c1) {
      var value = c1.value;
      var tolerance = c1.desiredTolerance;
      var minimum = c1.minimum;
      var maximum = c1.maximum;
      result = { name: 'c1', value: value, tolerance: tolerance, minimum: minimum, maximum: maximum };
    }

    return result;
  }

  @computed('circuit') get c2() {
    var c2 = this.circuit.c2;
    var result = { name: '', value: null, tolerance: null, minimum: null, maximum: null };
    if (c2) {
      var value = c2.value;
      var tolerance = c2.desiredTolerance;
      var minimum = c2.minimum;
      var maximum = c2.maximum;
      result = { name: 'c2', value: value, tolerance: tolerance, minimum: minimum, maximum: maximum };
    }

    return result;
  }

  @computed('circuit') get c5() {
    var c5 = this.circuit.c5;
    var result = { name: '', value: null, tolerance: null, minimum: null, maximum: null };
    if (c5) {
      var value = c5.value;
      var tolerance = c5.desiredTolerance;
      var minimum = c5.minimum;
      var maximum = c5.maximum;
      result = { name: 'c5', value: value, tolerance: tolerance, minimum: minimum, maximum: maximum };
    }

    return result;
  }

  @computed('circuit') get r1() {
    var r1 = this.circuit.r1;
    var result = { name: '', value: null, tolerance: null, minimum: null, maximum: null };
    if (r1) {
      var value = r1.value;
      var tolerance = r1.desiredTolerance;
      var minimum = r1.minimum;
      var maximum = r1.maximum;
      result = { name: 'r1', value: value, tolerance: tolerance, minimum: minimum, maximum: maximum };
    }

    return result;
  }

  @computed('circuit') get r2() {
    var r2 = this.circuit.r2;
    var result = { name: '', value: null, tolerance: null, minimum: null, maximum: null };
    if (r2) {
      var value = r2.value;
      var tolerance = r2.desiredTolerance;
      var minimum = r2.minimum;
      var maximum = r2.maximum;
      result = { name: 'r2', value: value, tolerance: tolerance, minimum: minimum, maximum: maximum };
    }

    return result;
  }

  @computed('circuit') get r3() {
    var r3 = this.circuit.r3;
    var result = { name: '', value: null, tolerance: null, minimum: null, maximum: null };
    if (r3) {
      var value = r3.value;
      var tolerance = r3.desiredTolerance;
      var minimum = r3.minimum;
      var maximum = r3.maximum;
      result = { name: 'r3', value: value, tolerance: tolerance, minimum: minimum, maximum: maximum };
    }

    return result;
  }

  @computed('circuit') get r4() {
    var r4 = this.circuit.r4;
    var result = { name: '', value: null, tolerance: null, minimum: null, maximum: null };
    if (r4) {
      var value = r4.value;
      var tolerance = r4.desiredTolerance;
      var minimum = r4.minimum;
      var maximum = r4.maximum;
      result = { name: 'r4', value: value, tolerance: tolerance, minimum: minimum, maximum: maximum };
    }

    return result;
  }

  @computed('circuit') get r5() {
    var r5 = this.circuit.r5;
    var result = { name: '', value: null, tolerance: null, minimum: null, maximum: null };
    if (r5) {
      var value = r5.value;
      var tolerance = r5.desiredTolerance;
      var minimum = r5.minimum;
      var maximum = r5.maximum;
      result = { name: 'r5', value: value, tolerance: tolerance, minimum: minimum, maximum: maximum };
    }

    return result;
  }

  @computed('circuit') get l1() {
    var l1 = this.circuit.l1;
    var result = { name: '', value: null, tolerance: null, minimum: null, maximum: null };
    if (l1) {
      var value = l1.value;
      var tolerance = l1.desiredTolerance;
      var minimum = l1.minimum;
      var maximum = l1.maximum;
      result = { name: 'l1', value: value, tolerance: tolerance, minimum: minimum, maximum: maximum };
    }
    return result;
  }

  @computed('circuit') get opAmp() {
    var opAmpName = this.circuit.opAmp.partNumber;
    var result = { name: opAmpName, url: null };
    return result;
  }
}
